import cn from 'classnames';
import { Button, BUTTON_THEMES, Grid } from 'ht-styleguide';
import Chat from '@integrations/gladly/Chat/Gladly.methods';

import styles from './chatbox.module.scss';

type ChatBoxProps = {
  title?: string;
  text?: string;
  buttonText?: string;
};

const DEFAULT_TEXTS = {
  title: 'Need help deciding?',
  text: 'Chat with our agents and have your questions answered right away.',
  buttonText: 'Chat with an Agent',
};

const ChatBoxBlock = ({ title = DEFAULT_TEXTS.title, text = DEFAULT_TEXTS.text, buttonText = DEFAULT_TEXTS.buttonText }: ChatBoxProps) => {
  const textStyles = cn('p0 n900 paddingTop-small1 paddingBottom-small2', styles.text);
  const buttonStyles = cn(styles.button, 'marginX-small1');
  const containerStyles = cn(styles.container, 'paddingY-huge');

  return (
    <section className={containerStyles}>
      <Grid.Fluid>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lgOffset={3} lg={6}>
            <h3 className={styles.title}>{title}</h3>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lg={12}>
            <p className={textStyles}>{text}</p>
            <div className={buttonStyles}>
              <Button
                theme={BUTTON_THEMES.SECONDARY}
                onClick={() => {
                  Chat.open();
                }}
              >
                {buttonText}
              </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

export default ChatBoxBlock;
